import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import PrimaryButton from '../PrimaryButton';
import { globalStyles } from '../style/gstheme';

const styles = Object.assign({
}, globalStyles);

class ImportWarningDialog extends React.Component {

    onComplete = () => {
        this.props.onContinue();
        this.props.history.push("/");
    }

    render() {

        const { classes, complete } = this.props;

        return (
            <React.Fragment>
                <Dialog
                    data-test="import-warning"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={true} aria-labelledby="import-warning-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="component-dialog-title">{
                        complete ?
                            "Import is complete"
                            :
                            "Import is in progress"
                    }</DialogTitle>
                    <DialogContent>
                        <Typography paragraph variant="body2">Apologies for this interruption!</Typography>
                        <Typography paragraph variant="body2">An import by another user is in progress in a project for which you have the data loaded.</Typography>
                        <Typography paragraph variant="body2">Editing is not permitted whilst imports are happening. We would recommend co-ordinating between a project team before importing to avoid impacting other users in this way.</Typography>
                        <Typography paragraph variant="body2">On completion all data will be reloaded to ensure that the impact of any imported data is accounted for.</Typography>
                        {complete ?
                            <Typography paragraph variant="body2">The import is complete. Please click Continue to reload data.</Typography>
                            :
                            <Typography paragraph variant="body2">Please wait, this should not take too long.</Typography>
                        }
                        <div style={{ textAlign: 'center', padding: 20 }}>
                            <PrimaryButton disabled={!complete} onClick={this.onComplete}>Continue</PrimaryButton>
                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    }
}

ImportWarningDialog.defaultProps = {
    complete: false
};

ImportWarningDialog.propTypes = {
    history: PropTypes.object,
    classes: PropTypes.object,
    complete: PropTypes.bool,
    onContinue: PropTypes.func.isRequired
};

export default withRouter(withStyles(styles)(ImportWarningDialog));